// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

/**
 * ng-autofocus - v0.0.1 - Mimics the HTML input attribute autofocus but instead
 * focuses the element when the directive is displayed not just on page load
 *
 * @author Ian Kennington Walter (http://ianvonwalter.com)
 */
hq.directive('focus', function () {
    return {
        restrict: 'A',
        link: function ($scope, element) {
            element[0].focus();
        }
    };
});
hq.directive('bootDatepicker', function () {
    return {
        require: '?ngModel',
        restrict: 'A',
        link: function ($scope, element, attrs, controller) {
            var updateModel;
            updateModel = function (ev) {
                element.datepicker('hide');
                element.blur();
                return $scope.$apply(function () {
                    return controller.$setViewValue(ev.date);
                });
            };
            if (controller != null) {
                controller.$render = function () {
                    // element.datepicker().data().datepicker.date = moment(controller.$viewValue).format();
                    // element.datepicker('setValue', controller.$viewValue);
                    element.val(controller.$viewValue);
                    element.datepicker('update');
                    return controller.$viewValue;
                };
            }
            return attrs.$observe('bootDatepicker', function (value) {
                var options;
                options = {};
                if (angular.isObject(value)) {
                    options = value;
                }
                if (typeof (value) === "string" && value.length > 0) {
                    options = angular.fromJson(value);
                }
                options.format = "dd.mm.yyyy";
                return element.datepicker(options).on('changeDate', updateModel);
            });
        }
    };
});

hq.directive('loading', ['$rootScope', function ($rootScope) {
    return {
        restrict: 'E',
        scope: { showLoadingIndicator: '&' },
        templateUrl: '/partials/controls/loading.html'+hq.linkVersion,
        link: function (scope, element, attrs) {
            if (!attrs.showLoadingIndicator) {
                scope.showLoadingIndicator = $rootScope.isLoading;
            }
        }
    };
}]);

hq.directive('switch', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel', pactasDisabled: '&', pactasOnAction: '&', pactasOffAction: '&' },
        templateUrl: '/partials/controls/switch.html' + hq.linkVersion,
        replace: false
    };
});

hq.directive("entity", ['EntityNames', '$rootScope', function (EntityNames, $rootScope) {
    return {
        template: '<a target="_blank" ng-href="/#/entities/{{entityId}}" title="{{entityId}}">{{$root.entityNames[entityId] || entityId}}</a>',
        restrict: 'E',
        scope: {
            entityId: "@"
        },
        link: function () {
            $rootScope.entityNames =$rootScope.entityNames|| EntityNames.get();
        }
    };
}]);

hq.directive("user", ['UserNames', '$rootScope', function (UserNames, $rootScope) {
    return {
        template: '<span title="{{userId}}">{{$root.userNames[userId][field || "Display"] || userId}}</span>',
        restrict: 'E',
        scope: {
            userId: "@",
            field: "@"
        },
        link: function () {
            $rootScope.userNames = $rootScope.userNames || UserNames.get();
        }
    };
}]);

hq.directive('paginatorControls', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel' },
        templateUrl: '/partials/controls/paginator-controls.html'
    };
});

angular.module('ui.config', []).value('ui.config', {});
angular.module('ui.filters', ['ui.config']);
angular.module('ui.directives', ['ui.config']);
angular.module('ui', ['ui.filters', 'ui.directives', 'ui.config']);
/**
* Enhanced Select2 Dropmenus
*
* @AJAX Mode - When in this mode, your value will be an object (or array of objects) of the data used by Select2
*     This change is so that you do not have to do an additional query yourself on top of Select2's own query
* @params [options] {object} The configuration options passed to $.fn.select2(). Refer to the documentation
*/
angular.module('ui.directives').directive('uiSelect2', ['ui.config', '$timeout', function (uiConfig, $timeout) {
    var options = {};
    if (uiConfig.select2) {
        angular.extend(options, uiConfig.select2);
    }
    return {
        require: '?ngModel',
        compile: function (tElm, tAttrs) {
            var watch,
        repeatOption,
        repeatAttr,
        isSelect = tElm.is('select'),
        isMultiple = (tAttrs.multiple !== undefined);

            // Enable watching of the options dataset if in use
            if (tElm.is('select')) {
                repeatOption = tElm.find('option[ng-repeat], option[data-ng-repeat]');

                if (repeatOption.length) {
                    repeatAttr = repeatOption.attr('ng-repeat') || repeatOption.attr('data-ng-repeat');
                    watch = jQuery.trim(repeatAttr.split('|')[0]).split(' ').pop();
                }
            }

            return function (scope, elm, attrs, controller) {
                // instance-specific options
                var opts = angular.extend({}, options, scope.$eval(attrs.uiSelect2));

                if (isSelect) {
                    // Use <select multiple> instead
                    delete opts.multiple;
                    delete opts.initSelection;
                } else if (isMultiple) {
                    opts.multiple = true;
                }

                if (controller) {
                    // Watch the model for programmatic changes
                    controller.$render = function () {
                        if (isSelect) {
                            elm.select2('val', controller.$modelValue);
                        } else {
                            if (isMultiple) {
                                if (!controller.$modelValue) {
                                    elm.select2('data', []);
                                } else if (angular.isArray(controller.$modelValue)) {
                                    elm.select2('data', controller.$modelValue);
                                } else {
                                    elm.select2('val', controller.$modelValue);
                                }
                            } else {
                                if (angular.isObject(controller.$modelValue)) {
                                    elm.select2('data', controller.$modelValue);
                                } else {
                                    elm.select2('val', controller.$modelValue);
                                }
                            }
                        }
                    };

                    // Watch the options dataset for changes
                    if (watch) {
                        scope.$watch(watch, function (newVal, oldVal, scope) {
                            if (!newVal) return;
                            // Delayed so that the options have time to be rendered
                            $timeout(function () {
                                elm.select2('val', controller.$viewValue);
                                // Refresh angular to remove the superfluous option
                                elm.trigger('change');
                            });
                        });
                    }

                    if (!isSelect) {
                        // Set the view and model value and update the angular template manually for the ajax/multiple select2.
                        elm.bind("change", function () {
                            scope.$apply(function () {
                                controller.$setViewValue(elm.select2('data'));
                            });
                        });

                        if (opts.initSelection) {
                            var initSelection = opts.initSelection;
                            opts.initSelection = function (element, callback) {
                                initSelection(element, function (value) {
                                    controller.$setViewValue(value);
                                    callback(value);
                                });
                            };
                        }
                    }
                }

                attrs.$observe('disabled', function (value) {
                    elm.select2(value && 'disable' || 'enable');
                });

                if (attrs.ngMultiple) {
                    scope.$watch(attrs.ngMultiple, function (newVal) {
                        elm.select2(opts);
                    });
                }

                // Set initial value since Angular doesn't
                elm.val(scope.$eval(attrs.ngModel));

                // Initialize the plugin late so that the injected DOM does not disrupt the template compiler
                $timeout(function () {
                    elm.select2(opts);
                    // Not sure if I should just check for !isSelect OR if I should check for 'tags' key
                    if (!opts.initSelection && !isSelect)
                        controller.$setViewValue(elm.select2('data'));
                });
            };
        }
    };
} ]);

hq.directive('passwordStrengthMeter', [function () {
    return {
        restrict: 'E',
        scope: {
            estimationResult: '=estimationResult'
        },
        templateUrl: '/partials/controls/password-strength-meter.html',
        replace: true
    };

    gettext("TooShort");
    gettext("TooWeak");
    gettext("Weak");
    gettext("Acceptable");
    gettext("Good");
    gettext("Strong");
}]);

hq.directive('paymentProviders', function () {
    return {
        restrict: 'E',
        scope: {
            value: '=value',
            isEnumValues:'=isEnumValues'
        },
        templateUrl: '/partials/controls/payment-providers.html'
    };
});

hq.directive('paymentMethods', function () {
    return {
        restrict: 'E',
        scope: {
            value: '=value'
        },
        templateUrl: '/partials/controls/payment-methods.html'
    };
});

hq.directive('infobox', function () {
    return {
        restrict: 'E',
        scope: { pactasShow: '&', header: '@' },
        transclude: true,
        templateUrl: '/partials/controls/infobox.html'
    };
});

hq.directive('disableAll', DisableAll);

hq.directive('pgLogLevel', PgLogLevel);
hq.directive('pgMigrationStatus', PgMigrationStatus);
